"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var FormsStore = (function () {
    function FormsStore() {
        var _this = this;
        this.state = {};
        this.subscribers = {};
        this.initForm = function (formName, initialForm) {
            if (initialForm === void 0) { initialForm = {}; }
            _this.state[formName] = __assign({}, initialForm);
            _this.subscribers[formName] = [];
        };
        this.subscribe = function (formName, listener) {
            if (_this.subscribers[formName]) {
                _this.subscribers[formName].push(listener);
            }
        };
        this.validate = function (formName) {
            if (!_this.state[formName]) {
                return true;
            }
            var form = _this.state[formName];
            if (Object.keys(form).length > 0) {
                Object.keys(form).forEach(function (key) {
                    form[key] = __assign({}, form[key], { touched: true });
                });
                _this.sendNotificationToSubscribers(formName);
                return !Object.keys(form).find(function (key) { return !form[key].isValid; });
            }
            return true;
        };
        this.getFormData = function (formName) {
            if (!_this.state[formName]) {
                console.error('Form', formName, 'is not inited');
            }
            return _this.state[formName] || {};
        };
        this.setFieldData = function (fieldName, fieldData, formName) {
            if (!_this.state[formName] || !_this.state[formName][fieldName]) {
                console.error('Form', formName, 'is not inited');
                return null;
            }
            var form = _this.state[formName];
            var currentField = form[fieldName];
            _this.state[formName] = __assign({}, form, (_a = {}, _a[fieldName] = __assign({}, currentField, fieldData, { touched: true }), _a));
            _this.sendNotificationToSubscribers(formName);
            var _a;
        };
        this.sendNotificationToSubscribers = function (formName) {
            var form = _this.state[formName];
            _this.subscribers[formName].forEach(function (subscriber) { return subscriber(form); });
        };
    }
    FormsStore.prototype.reset = function () {
        this.state = {};
        this.subscribers = {};
    };
    return FormsStore;
}());
exports.default = (new FormsStore());
//# sourceMappingURL=FormsStore.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/data/FormsStore/FormsStore.js
// module id = 194
// module chunks = 0 1